<template>
  <div :class="ns.b()">
    <span :class="ns.e('icon')">
      <slot name="icon">
        <z-icon><star /></z-icon>
      </slot>
    </span>
    <p v-if="title || $slots.title" :class="ns.e('title')">
      <slot name="title">{{ title }}</slot>
    </p>
    <p v-if="description || $slots.description" :class="ns.e('desc')">
      <slot name="description">{{ description }}</slot>
    </p>
    <slot />
  </div>
</template>

<script lang="ts" setup>
import { Star } from '@zoryn/icons'
import { useNamespace } from '@zoryn/hooks'
import ZIcon from '@zoryn/components/icon'
import type { DashboardEmptyProps } from './dashboard'

defineOptions({
  name: 'ZDashboardEmpty',
})

withDefaults(defineProps<DashboardEmptyProps>(), {
  title: '暂无常用模块',
  description: '在功能卡片右上角点星标即可收藏',
})

const ns = useNamespace('dashboard-empty')
</script>
